import { Grid, InputLabel, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { XCircle } from '../../icons/x-circle';
import { TALENTS_BASIC_INPUTS_NAME } from './Constants';
import { styleTalentDetails, rowStyle } from './style';

type PropsBasicEmailRow = {
  label: string,
  value: string,
  // onDeleteClick: () => void,
  onValueChange: (e:React.ChangeEvent<HTMLInputElement>) => void
  onDeleteEmail: () => void,
  error: string,
  isShowDeleteButton: boolean,
  placeholder: string,
};

export const BasicEmailRow = (
  {
    label,
    value,
    // onDeleteClick,
    error,
    onValueChange,
    onDeleteEmail,
    isShowDeleteButton,
    placeholder,
  }:PropsBasicEmailRow)
  :JSX.Element => {
  return (
    <Grid sx={ styleTalentDetails.cardContent.form.box }
      style={
        {
          backgroundColor: error ?
            styleTalentDetails.cardContent.form.error.backgroundColor : 'unset',
        }
      }
      container
    >
      <Grid item xs={ styleTalentDetails.cardContent.form.boxLabel.xs }>
        <InputLabel
          htmlFor={ TALENTS_BASIC_INPUTS_NAME.EMAIL }
          style={ styleTalentDetails.cardContent.form.InputLabel }
        >
          { label }
        </InputLabel>
      </Grid>
      <Grid item xs={ styleTalentDetails.cardContent.form.boxInput.xs }>
        <TextField
          variant="standard"
          name={ TALENTS_BASIC_INPUTS_NAME.EMAIL }
          fullWidth
          value={ value }
          onChange={ onValueChange }
          placeholder={ placeholder }
          InputProps={ {
            style: styleTalentDetails.cardContent.form.TextField,
            disableUnderline: true,
          } }
        />
      </Grid>
      <Grid item
        xs={ styleTalentDetails.cardContent.form.boxIcon.xs }
        textAlign={ styleTalentDetails.cardContent.form.boxIcon.textAlign }
      >
        <Box sx={ styleTalentDetails.cardContent.form.boxIcon.box  }>
          {isShowDeleteButton && (
            <Box onClick={ onDeleteEmail } style={ rowStyle.iconWrapper.style }>
              <XCircle style={ rowStyle.xCircleIcon.style } />
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
